import featureFlags from "@/constants/feature-flags";
import useFeatureFlag from "@/hooks/use-feature-flag";
import { components } from "@/lib/openapi/schemas/service-telegram-authorization";
import { FC, PropsWithChildren } from "react";
import { Navigate, Outlet } from "react-router";

const FeatureFlagGuard: FC<
  {
    featureFlag: keyof typeof featureFlags;
    user?: components["schemas"]["UserResponse"];
    negative?: boolean;
  } & PropsWithChildren
> = ({ featureFlag, negative, user, children }) => {
  const { featureFlag: featureFlagData } = useFeatureFlag(
    featureFlag,
    {
      user,
    }
  );

  if (featureFlagData === (negative ?? false))
    return <Navigate to="/" replace />;
  return children ?? <Outlet />;
};

export default FeatureFlagGuard;
